module.exports = __webpack_public_path__ + "e4eaea15b0939a0df1f17bb0ffe88b0e.jpg";